import { AuthProvider } from 'react-admin';
import {
    CognitoUserPool,
    // CognitoUserAttribute,
    CognitoUser,
    AuthenticationDetails,
} from 'amazon-cognito-identity-js';
import i18nProvider from './i18n'
// import { schema, schemaData } from './personalize';

function jwtDecode(t: string) {
    let token = {} as any;
    token.raw = t;
    token.header = JSON.parse(window.atob(t.split('.')[0]));
    token.payload = JSON.parse(window.atob(t.split('.')[1]));
    return (token)
}

const userPool = new CognitoUserPool({
    UserPoolId: 'us-west-2_t5SDpNAIm',
    ClientId: '6661qlm3lcmdmckvkl4keritjj',
})

const authProvider: AuthProvider = {
    login: ({ username, password }) => {
        // return Promise.resolve();

        const cognitoUser = new CognitoUser({
            Username: username,
            Pool: userPool,
        })

        const authenticationDetails = new AuthenticationDetails({
            Username: username,
            Password: password,
        });

        return new Promise((resolve, reject) => {
            cognitoUser.authenticateUser(authenticationDetails, {
                onSuccess: function (result) {
                    var accessToken = result.getIdToken().getJwtToken();
                    // console.log(accessToken)
                    localStorage.setItem('username', username)
                    localStorage.setItem('token', accessToken);

                    resolve('')
                },

                onFailure: function (err) {
                    console.log(err.message || JSON.stringify(err));
                    reject()
                },
            });
        })
        // return Promise.resolve()
    },
    logout: () => {
        try {
            var cognitoUser = new CognitoUser({
                Username: localStorage.getItem('username')!,
                Pool: userPool,
            })
            cognitoUser.signOut()

        } catch (err) {

        }
        localStorage.removeItem('username');
        localStorage.removeItem('token');
        return Promise.resolve();
    },
    checkError: (error) => {
        console.log(JSON.stringify(error))
        // console.log(body)
        // if (error.status === 200) {
        if (error.message.includes("JWTExpired") ||
            error.message.includes("JWSError") ||
            error.message.includes("JWSInvalidSignature")) {
            localStorage.removeItem('token');
            return Promise.reject();
        }
        // } else if (error.status > 400) {
        //     return Promise.reject()
        // }

        return Promise.resolve();
    },
    checkAuth: () => {
        // const redirect = schemaData.loginRedirect ? /a/ : undefined
        // console.log(redirect)

        return localStorage.getItem('token') ? Promise.resolve() : Promise.reject()
    },
    getIdentity: () => {
        const token = localStorage.getItem('token')
        if (token && token !== '') {
            //const { payload } = jwtDecode(token)
            // console.log(header, payload)
            //const claims = payload['https://hasura.io/jwt/claims']
            // const userId = claims['x-hasura-user-id']
            return Promise.resolve({
                id: 'user',
                fullName: i18nProvider.translate('resources.common.fields.home'),
                // avatar: 'https://avatars.githubusercontent.com/u/2219914?v=4',
            })
        }
        return Promise.reject()
    },
    // getPermissions: () => localStorage.getItem('token') ? Promise.resolve() : Promise.reject(),
    getPermissions: (params) => {
        const token = localStorage.getItem('token')
        if (token && token !== '') {
            try {
                const { payload } = jwtDecode(token)
                // console.log(header, payload)
                const claims = JSON.parse(payload['https://hasura.io/jwt/claims'])
                const allowedRoles = claims['x-hasura-allowed-roles']
                const defaultRole = claims['x-hasura-default-role']
                return Promise.resolve({
                    allowedRoles,
                    defaultRole,
                })
            } catch (err) {
                console.log(err)
                return Promise.reject({ allowedRoles: [], defaultRole: '' })
            }
        }
        return Promise.reject({ allowedRoles: [], defaultRole: '' }) //{ allowedRoles: [], defaultRole: '' } //Promise.reject('Unknown method')
    }

};

export default authProvider;
